import { Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";

const QuickOptionButton = ({ title, icon, onClick }) => {
  return (
    <Col xs="4" className="my-4">
      <div
        onClick={() => onClick()}
        style={{ border: '1px solid rgb(66, 66, 66)' }}
        className="option-box btn-outline-primary rounded-2 h-100 d-flex flex-column justify-content-center align-items-center"
      >
        {icon}
        <H6>{title}</H6>
      </div>
    </Col>
  );
};

export default QuickOptionButton;
